import * as dayjs from 'dayjs';
import * as RelativeTime from 'dayjs/plugin/relativeTime';

// @see: https://day.js.org/docs/en/customization/relative-time
dayjs.extend(RelativeTime);

export default dayjs;
